var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStageGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 3,
    viewBox: "0 0 20 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.44531L17.5 0.00193691L17.5 2.88869L20 1.44531ZM0 1.44531L-1.69966e-09 1.69531L17.75 1.69531L17.75 1.44531L17.75 1.19531L1.69966e-09 1.19531L0 1.44531Z",
    fill: "#C1F700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageGreenArrow);
export default __webpack_public_path__ + "static/media/stage-green-arrow.f04315f38da014283ec41f53876ddac3.svg";
export { ForwardRef as ReactComponent };